<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <h2>مدیریت حواله های خروجی</h2>
            <ul class="breadcrumb mt-3">
              <li class="breadcrumb-item">
                <a href="#" @click="$store.state.contentPane='Dashboard'">
                  <i class="zmdi zmdi-home"></i>پنل مدیریت
                </a>
              </li>

              <li class="breadcrumb-item active">
                <a href="#">مدیریت حواله های خروجی</a>
              </li>
              <li class="breadcrumb-item active">
                <a href="#" ref="BreadCrumbTitle">
                  سفارش گذاری
                </a>
              </li>
            </ul>
            <button class="btn btn-primary btn-icon mobile_menu" type="button">
              <i class="zmdi zmdi-sort-amount-desc"></i>
            </button>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12 text-left">
            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button">
              <i class="zmdi zmdi-arrow-right align-middle"></i>
            </button>
            <!--            <div class="dropdown float-left">
                          <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                            دسترسی
                            <i class="zmdi zmdi-caret-down" style="vertical-align:middle;"></i>
                          </button>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#" @click="panelActive='ProductionPlanningDashboard'">برنامه ریزی
                              تولید</a>
                            <a class="dropdown-item" href="#" @click="panelActive='OrderingDashboard'">سفارش گذاری</a>
                            <a class="dropdown-item" href="#" @click="panelActive='InspectorsDashboard'">بازرسی</a>
                            <a class="dropdown-item" href="#" @click="panelActive='LogisticsDashboard'">شناسنامه ارسال محموله</a>
                            <a class="dropdown-item" href="#" @click="panelActive='ShipmentDashboard'">کارتابل ارسال محموله</a>
                          </div>
                        </div>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="فروشگاه جدید"
                            data-color="red"
                            data-toggle="modal"
                            @click="openNewShopModal()"
                        >
                          <i class="zmdi zmdi-plus align-middle"></i>
                          فروشگاه جدید
                        </button>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="دانلود PDF لیست فروشگاه ها"
                            data-color="red"
                            data-toggle="modal"
                            @click="downloadShopList()"
                        >
                          <i class="zmdi zmdi-download align-middle"></i>
                          دانلود PDF لیست فروشگاه‌ها
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openNewContractModal">
                          قرارداد جدید
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openFindCustomerModal">
                          فیلتر گذاری
                        </button>-->
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
              <div class="row pr-3">
                <form class="form-inline">
                  <div class="form-group mb-2">
                    <select v-model="pageSize" class="form-control">
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: فیلتر گذاری ::.
                    </div>
                    <div class="col text-left">
                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                        <small ref="a_CloseFilterPanel">
                          نمایش
                        </small>
                      </a>
                    </div>
                  </div>


                </div>
                <div class="card-body bg-white" v-if="isOpenFilterPanel">
                  <form @submit.prevent="startFilterPendingOrders">
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">حواله سازنده</label>
                          <input type="text" class="form-control text-left" v-model="order.InvoiceNumber">
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">مشتری</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.CustomerId">
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">محل تحویل</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.WarehouseId">
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">
                              {{ item.WarehouseTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">رسیدن به مقصد</label>
                          <div class="row">
                            <div class="col">
                              <!--                              <input type="text" class="form-control text-left" v-model="order.EstimatedArrivalTime">-->
                              <date-picker
                                  type="datetime"
                                  :autoSubmit="true"
                                  format="YYYY-MM-DD HH:mm"
                                  display-format="jYYYY/jMM/jDD-HH:mm"
                                  v-model="order.EstimatedArrivalTime" inputClass="form-control text-left"
                              ></date-picker>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">تامین کننده</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.SupplierId">
                            <option value="678b97bab3f8164454040d18">
                              بهران موتور گلپایگان
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">توضیحات</label>
                          <input type="text" class="form-control text-right" v-model="order.OrderDescription">
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 mb-2">
                      <div class="col border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">نوع خودرو</label>
                          <select
                              class="form-control show-tick ms select2"
                              data-placeholder="انتخاب کنید"
                              style="height:auto;" v-model="filterPendingOrders.VehicleId">
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">
                              {{ item.VehicleTitle }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          گزارش گیری
                        </button>
                        <button class="btn btn-success" type="button" v-if="order.Orders.length>0" @click="submitOrder">
                          تایید ارسال
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered table-hover"
                  >
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center">انتخاب</th>
                      <th class="text-center">شرح قطعه</th>
                      <th class="text-center">شماره فنی</th>
                      <th class="text-center">کدکالا</th>
                      <th class="text-center">تعداد پالت</th>
                      <th class="text-center">نوع پالت</th>
                      <th class="text-center">وضعیت کیفی</th>
                      <th class="text-center">وضعیت موجودی</th>
                      <th class="text-center">زمان آزاد سازی</th>
                      <th class="text-center">زمان اعتبار</th>
                      <th class="text-center">شماره محموله</th>
                      <!--                      <th class="text-center">درخواست ابطال</th>-->
                      <th class="text-center">نام خودرو</th>
                      <th class="text-center">نام مشتری</th>
                      <th class="text-center">تعداد در پالت</th>
                      <th class="text-center">نوع ارسال</th>
                      <th class="text-center">تعداد</th>
                      <th class="text-center">تعداد ارسال</th>

                      <th class="text-center" style="white-space: nowrap;">عملیات</th>
                    </tr>
                    </thead>
                    <!--                    <tfoot class="bg-info">
                                        </tfoot>-->
                    <tbody class="text-center">
                    <tr v-if="pendingOrdersData.PendingOrderList.length===0">
                      <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="(item,index) in pendingOrdersData.PendingOrderList" :key="item._id"
                        :class="{ 'highlight': item.selected,'disabled-row': !item.IsOrderable }"  >
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">
                        <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                               @change="addToOrderList(item, $event)">
                      </td>
                      <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                      <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                      <td class="p-1 align-middle">{{ item.ItemCode }}</td>
                      <td class="p-1 align-middle">{{ item.PalletQuantity }}</td>
                      <td class="p-1 align-middle">{{ item.PalletType }}</td>
                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <i class="zmdi zmdi-flag"></i>
                        </span>
                      </td>
                      <td class="p-1 align-middle">
                        <span class="text-success">
                          <i class="zmdi zmdi-circle"></i>
                        </span>
                      </td>
                      <td class="p-1 align-middle">{{ item.ReleaseTime | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.ValidTime | moment("jYYYY/jM/jD-HH:mm") }}</td>
                      <td class="p-1 align-middle">{{ item.ShipmentNumber }}</td>
                      <!--<td class="p-1 align-middle">{{ item.asn_date_persian }}</td>-->
                      <td class="p-1 align-middle">{{ item.VehicleDetail.VehicleTitle }}</td>
                      <td class="p-1 align-middle">{{ item.CustomerDetails.CustomerTitle }}</td>
                      <td class="p-1 align-middle">{{ item.QuantityPerPallet }}</td>
                      <td class="p-1 align-middle">{{ item.ShippingType }}</td>
                      <td class="p-1 align-middle">{{ item.Quantity }}</td>
                      <td class="p-1 align-middle">
                        <input type="number" class="form-control" :value="item.Quantity" min="1" :max="item.Quantity"
                               @input="updateOrderQuantity(item, $event.target.value)">
                      </td>
                      <td class="p-1 align-middle">
                        <!--                        <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="تایید محموله بدون بندیل"
                                                    @click="openEditContractModal(item)"
                                                >
                                                  <i class="zmdi zmdi-check align-middle text-white"></i>
                                                  تایید محموله بدون بندیل
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="تایید محموله با بندیل"
                                                    @click="openConfirmBundledShipmentModal(item)"
                                                >
                                                  <i class="zmdi zmdi-check align-middle text-white"></i>
                                                  تایید محموله با بندیل
                                                </a>-->
                        <a
                            href="#"
                            class="m-1 btn btn-info btn-sm"
                            title="نمایش جزییات"
                            @click="openShipmentInfoModal(item)"
                        >
                          <i class="zmdi zmdi-eye align-middle text-white"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div class="modal fade" id="div_AlertModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_AlertModalMessage"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="modal fade" id="div_NewPendingOrderModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">محموله جدید</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">شرح قطعه</label>
                      <input type="text" class="form-control text-right" v-model="newShipment.PartDescription">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">شماره فنی</label>
                      <input type="text" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.PartNumber">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">کد کالا</label>
                      <input type="text" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.ItemCode">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">تعداد پالت</label>
                      <input type="number" class="form-control text-left" style="direction: ltr;" min="1"
                             v-model="newShipment.PalletQuantity">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">نوع پالت</label>
                      <select class="form-control" v-model="newShipment.PalletType">
                        <option value="MS174">پالت نوع 1</option>
                        <option value="MS175">پالت نوع 2</option>
                        <option value="MS176">پالت نوع 3</option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">زمان آزاد سازی</label>
                      <date-picker
                          type="datetime"
                          :autoSubmit="true"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                          v-model="newShipment.ReleaseTime"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">زمان اعتبار</label>
                      <date-picker
                          type="datetime"
                          :autoSubmit="true"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                          v-model="newShipment.ValidTime"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">شماره محموله</label>
                      <input type="text" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.ShipmentNumber">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">مشتری</label>
                      <select class="form-control" v-model="newShipment.CustomerId">
                        <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                        <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                            item.CustomerTitle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">انبار</label>
                      <select class="form-control" v-model="newShipment.WarehouseId">
                        <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                        <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">{{
                            item.WarehouseTitle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">خودرو</label>
                      <select class="form-control" v-model="newShipment.VehicleId">
                        <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                        <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">{{
                            item.VehicleTitle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">نوع ارسال</label>
                      <select class="form-control" v-model="newShipment.ShippingType">
                        <option value="کانبان مشتری">کانبان مشتری</option>
                      </select>
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">تعداد در پالت</label>
                      <input type="number" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.QuantityPerPallet">
                    </div>
                  </div>
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">تعداد</label>
                      <input type="number" class="form-control text-left" style="direction: ltr;"
                             v-model="newShipment.Quantity">
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;text-align: right;">
                <button class="btn btn-success" @click="addNewPendingOrder">
                  ثبت محموله
                </button>
                <button class="btn btn-danger" data-dismiss="modal">
                  انصراف
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->


    <!--    <div class="modal fade" id="div_EditShipmentModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">ویرایش محموله</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div class="row bg-light p-2 mb-3">
                <div class="col">
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        نام سازنده:
                      </span>
                      {{ shipment?.SupplierDetail?.SupplierTitle }}
                    </div>
                    <div class="col">
                      <span>
                        کد سازنده:
                      </span>
                      {{ shipment?.SupplierDetail?.SupplierCode }}
                    </div>
                    <div class="col">
                      <span>
                        شماره محموله:
                      </span>
                      {{ shipment?.ShipmentNumber }}

                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        مشتری:
                      </span>
                      {{ shipment?.CustomerDetails?.CustomerTitle }}
                    </div>
                    <div class="col">
                      <span>
                        محل تحویل:
                      </span>
                      {{ shipment?.WarehouseDetail?.WarehouseTitle }}
                    </div>
                    <div class="col">

                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        تاریخ ثبت:
                      </span>
                      {{ shipment?.CreatedAt | moment("jYYYY/jM/jD") }}
                    </div>
                    <div class="col">
                      <span>
                        تاریخ تحویل:
                      </span>
                      {{ shipment?.EstimatedArrivalTime | moment("jYYYY/jM/jD") }}
                    </div>
                    <div class="col">
                      <span>
                        تاریخ بازرسی:
                      </span>
                      {{ shipment?.ConfirmedAt | moment("jYYYY/jM/jD") }}
                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <form class="form-inline">
                        <div class="form-group mb-2">
                          <label for="staticEmail2">شماره حواله سازنده: </label>
                          &nbsp;
                          <input type="text" class="form-control" v-model="shipment.ShipmentNumber">
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                          <label for="inputPassword2">توضیحات: </label>
                          &nbsp;
                          <input type="text" class="form-control" id="inputPassword2" v-model="shipment.Desc">
                        </div>
                      </form>
                    </div>


                  </div>
                </div>
              </div>
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">شرح قطعه</th>
                            <th class="text-center">شماره فنی</th>
                            <th class="text-center">کد کالا</th>
                            <th class="text-center">تعداد ارسالی</th>
                            <th class="text-center">گواهی مرغوبیت</th>
                            <th class="text-center">ابطال</th>
                            <th class="text-center">وضعیت</th>
                            <th class="text-center">آخرین بروزرسانی</th>
                            <th class="text-center">TestReport</th>
                            <th class="text-center">تعداد نهایی</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in shipment?.PendingOrder" :key="index"
                              :class="{'disabled-row': !completeAbandonButtonVisible || !orderItemsStatus(item.Status)}">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                            <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                            <td class="p-1 align-middle">{{ item.ItemCode }}</td>
                            <td class="p-1 align-middle">{{ item.OrderQuantity }}</td>
                            <td class="p-1 align-middle">{{ item.QualityCertificate }}</td>
                            <td class="p-1 align-middle">
                              <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                                     @change="addToAbandonList(item, $event)">
                            </td>
                            <td class="p-1 align-middle">
                              <span class="text-success">
                                <i class="zmdi zmdi-flag"></i>
                              </span>
                            </td>

                            <td class="p-1 align-middle">
                              <span v-if="item.UpdatedAt!=null">
                                {{ item.UpdatedAt | moment("jYYYY/jM/jD-HH:mm") }}
                              </span>
                            </td>
                            <td class="p-1 align-middle">
                              <span v-if="item.TestReport===null">
                                ندارد
                              </span>
                              <a href="#" target="_blank" v-else>
                                نمایش
                              </a>

                            </td>
                            <td class="p-1 align-middle">
                              <div class="d-flex align-items-center">
                                <input type="number" class="form-control" min="1" v-model="item.OrderQuantity"
                                       style="width:100px;text-align: left;direction: ltr;">
                                &nbsp;
                                <button type="button" class="btn btn-success"
                                        @click="updateOrderQuantity(item._id,item.OrderQuantity)"
                                        style="display: inline;">
                                  ثبت
                                </button>
                              </div>

                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;">
                <button type="button" class="btn btn-danger" @click="cancelOrderItems" v-if="cancelOrderItemsButtonVisible">
                  ابطال انتخابی ها
                </button>
                <button type="button" class="btn btn-danger" @click="completeAbandonment"
                        v-if="completeAbandonButtonVisible">
                  ابطال کل محموله
                </button>
                <button class="btn btn-primary" data-dismiss="modal">
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!--    <div class="modal fade" id="div_NewPendingOrderModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">محموله جدید</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شرح قطعه</label>
                          <input type="text" class="form-control text-right" v-model="newShipment.PartDescription">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.PartNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ItemCode">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;" min="1"
                                 v-model="newShipment.PalletQuantity">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع پالت</label>
                          <select class="form-control" v-model="newShipment.PalletType">
                            <option value="MS174">پالت نوع 1</option>
                            <option value="MS175">پالت نوع 2</option>
                            <option value="MS176">پالت نوع 3</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان آزاد سازی</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ReleaseTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان اعتبار</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ValidTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره محموله</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ShipmentNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">مشتری</label>
                          <select class="form-control" v-model="newShipment.CustomerId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">انبار</label>
                          <select class="form-control" v-model="newShipment.WarehouseId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">{{
                                item.WarehouseTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">خودرو</label>
                          <select class="form-control" v-model="newShipment.VehicleId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">{{
                                item.VehicleTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع ارسال</label>
                          <select class="form-control" v-model="newShipment.ShippingType">
                            <option value="کانبان مشتری">کانبان مشتری</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد در پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.QuantityPerPallet">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.Quantity">
                        </div>
                      </div>
                    </form>
                  </div>
                </simplebar>

              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col text-right" style="direction: rtl;text-align: right;">
                    <button class="btn btn-success" @click="addNewPendingOrder">
                      ثبت محموله
                    </button>
                    <button class="btn btn-danger" data-dismiss="modal">
                      انصراف
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from "vuejs-paginate";
// import Vue from 'vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

// import moment from "vue-moment-jalaali";
// import VueUploadMultipleImage from 'vue-upload-multiple-image';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  data() {
    return {
      order: {
        Orders: [],
        InvoiceNumber: null,
        EstimatedArrivalTime: null,
        OrderDescription: null,
        CustomerId: null,
        WarehouseId: null,
        SupplierId: null,
        VehicleId: null
      },
      isOpenFilterPanel: false,
      pendingOrdersData: {PendingOrderList: [], PendingOrdersCount: 0},
      loadingShow: false,
      pageSize: 10,
      filterPendingOrders: {
        CustomerId: null,
        WarehouseId: null,
        SupplierId: null,
        VehicleId: null
      },
      /*newShipment: {
        CustomerId: null,
        WarehouseId: null,
        VehicleId: null,
        PartDescription: null,
        PartNumber: null,
        ItemCode: null,
        PalletQuantity: 1,
        PalletType: null,
        ReleaseTime: null,
        ValidTime: null,
        ShipmentNumber: null,
        QuantityPerPallet: 1,
        ShippingType: null,
        Quantity: 1,
        QuantityShipped: 1
      },*/














      /*filterWaybill: {
        CustomerId: null,
        WarehouseId: null,
        FromDate: null,
        ToDate: null,
        OrderStatus: null,
        ShipmentNumber: null,
        InvoiceNumber: null
      },*/

      // shipment: {},
      orderId: null,
      abandonList: [],


      // panelActive: "",


      filterOrder: {
        FromDate: null,
        ToDate: null,
        SupplierId: null,
        OrderStatus: null,
        ShipmentNumber: ""
      },
      ordersData: {OrderList: [], OrdersCount: 0},
      pendingOrderData: {PendingOrderList: [], PendingOrderCount: 0},
      ordersNotInWaybillsData: {OrdersNotInWaybillsList: [], OrdersNotInWaybillsCount: 0},
      uploadTestFile: {
        OrderId: null,
        ItemId: null,
        TestReportFile: null
      },
      customers: [],
      vehicleList: [],
      warehouseList: [],



    };
  },
  methods: {
    submitOrder() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("/API/V1/Orders/SubmitOrder", self.order, {
        headers: {
          "Content-Type": "application/json",
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (res.data.Status === 1) {
              self.loadingShow = false;
              self.order = {
                Orders: [],
                InvoiceNumber: null,
                EstimatedArrivalTime: null,
                OrderDescription: null,
                CustomerId: null,
                WarehouseId: null,
                SupplierId: null,
                VehicleId: null
              }
              self.$refs.div_AlertModalMessage.innerHTML = `<h5 class="text-success text-center">محموله جدید با موفقیت ثبت شد</h5><p>شماره محموله : ${Data.DeclarationNumber}</p><p>شماره اظهارنامه: ${Data.ShipmentNumber}</p>`;
              $("#div_AlertModal").modal({backdrop: "static"});
            } else {
              /*self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });*/
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    updateOrderQuantity(item, value) {
      let self = this;
      const index = self.order.Orders.findIndex(i => i.OrderId === item._id);
      if (index > -1) {
        self.order.Orders[index].Quantity = parseInt(value);
      }
      console.log(self.order);
    },
    startFilterPendingOrders() {
      let self = this;
      self.getPendingOrders()
    },
    getPendingOrders(pageIndex = 1, limit = 10) {
      let self = this;
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/API/V1/PendingOrders/FilterPendingOrders", {
            params: self.filterPendingOrders,
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            let {Data, Status, Message} = res.data;
            if (Status === 1) {
              self.pendingOrdersData.PendingOrderList = Data.PendingOrders;
            } else {
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
            /*self.installmentsData.InstallmentsCount = res.data.Data.InstallmentsCount;
            let pageCount =
                self.installmentsData.InstallmentsCount % self.pageSize === 0
                    ? self.installmentsData.InstallmentsCount / self.pageSize
                    : self.installmentsData.InstallmentsCount / self.pageSize + 1;
            self.pageList = Math.floor(pageCount);*/
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    closeFilterPanel() {
      let self = this;
      self.isOpenFilterPanel = !self.isOpenFilterPanel;
      self.$refs.a_CloseFilterPanel.innerText = self.isOpenFilterPanel === true ? "بستن" : "نمایش";
    },

    getCustomersInfo() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("/API/V1/Customers/GetCustomers", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(res.data);

            if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    addToOrderList(item, event) {
      let self = this;
      console.log(item);
      if (event.target.checked) {
        self.order.Orders.push({OrderId: item._id, Quantity: parseInt(item.Quantity)});
      } else {
        self.order.Orders = self.order.Orders.filter(i => i.OrderId !== item._id);
      }
      console.log(self.order);
    },
  },
  created() {
    let self = this;
    // this.$refs.BreadCrumbTitle.innerText = "کارتابل ارسال محموله";
    this.getCustomersInfo();
    // $("#div_EditShipmentModal").modal("show");
  },
  mounted() {
    // $("#div_EditShipmentModal").modal("show");
  },
  computed: {
    /*completeAbandonButtonVisible() {
      return !["2","3","4"].includes(this.shipment?.OrderStatus);
    },
    cancelOrderItemsButtonVisible() {
      return !this.shipment?.PendingOrder?.every(order => ["2", "3", "4"].includes(order.Status));
    }*/
  },
  watch: {
    /*pageSize: function (val) {
      this.getInstallments(this.pageIndex, this.pageSize);
    },*/
    /*"filterPendingOrders.VehicleId": function (newValue, oldValue) {
      this.order.VehicleId = newValue;
    },
    "filterPendingOrders.SupplierId": function (newValue, oldValue) {
      this.order.SupplierId = newValue;
    },
    "filterPendingOrders.WarehouseId": function (newValue, oldValue) {
      this.order.WarehouseId = newValue;
    },
    "filterPendingOrders.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "newShipment.CustomerId": function (newValue, oldValue) {
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "panelActive": function (newValue, oldValue) {
      if (newValue === "LogisticsDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "حمل و نقل";
        this.getOrdersNotInWaybills();
      } else if (newValue === "InspectorsDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "بازرسی";
      } else if (newValue === "OrderingDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "سفارش گذاری";
        this.getCustomersInfo();
      } else if (newValue === "ProductionPlanningDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "برنامه ریزی تولید";
      } else if (newValue === "ShipmentDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "کارتابل ارسال محموله";
        this.getCustomersInfo();
      }
    },*/
    /*"filterWaybill.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },*/
    "newShipment.CustomerId": function (newValue, oldValue) {
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "filterPendingOrders.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "filterPendingOrders.VehicleId": function (newValue, oldValue) {
      this.order.VehicleId = newValue;
    },
    "filterPendingOrders.SupplierId": function (newValue, oldValue) {
      this.order.SupplierId = newValue;
    },
    "filterPendingOrders.WarehouseId": function (newValue, oldValue) {
      this.order.WarehouseId = newValue;
    },


  },
  components: {
    simplebar, 'paginate': Paginate, datePicker: VuePersianDatetimePicker,
  }
};
</script>

<style>
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  margin-bottom: 5px;
  text-transform: lowercase;
  font-variant: small-caps;
  text-align: right !important;
  direction: rtl !important;
  padding: 2px;
}

.text-right {
  direction: rtl !important;
  text-align: right !important;
}

.reset {
  all: revert;
}

.vpd-icon-btn {
  margin-bottom: 0px !important;
}

.mp-custom-input-text {
  font-size: 25px;
  direction: ltr;
  text-align: left;
}

.table-responsive {
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
  //min-height: 50px;
}

th {
  font-weight: initial !important;
}

.highlight {
  background-color: #B2FF59;
}

.bg-white {
  color: initial;
}

.disabled-row {
  background-color: #f0f0f0;
  color: #919090;
  pointer-events: none;
}

</style>
